
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';;
import Button from '@/models/ButtonModel';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'ref-button',

	components: {
		QAvatar
	},

	props: {
		button: {
			type: Object as PropType<Button>
		},

		leftIcon: {
			type: String
		},

		color: {
			type: String
		}
	},

	emits: ['click']
});
